<template>
  <section
    :class="[
				'block-wrapper', 
				'no-padding', 
				componentClass, 
				colorMode, 
        data.position,
				{
					visible: visible, 
					ready: ready, 
					'color-overlay': !data.text_under_banner && (data.quote || data.person_credit || data.publication),
					'negative-margin-bottom': data.text_under_banner
				}
			]"
  >
    <div
      v-if="data.background_image"
      v-bind:style="{ backgroundImage: 'url(' + bannerImageURL + ')' }"
      class="inner-image"
    >
      <div class="inner-container">
        <div v-if="!data.text_under_banner" class="row">
          <div class="small-12 columns credittext">
            <span v-if="data.person_credit" v-text="data.person_credit"></span>
            <span class="credit-divider" v-if="data.person_credit && data.publication">•</span>
            <span v-if="data.publication" v-text="data.publication"></span>
          </div>
        </div>
        <div v-if="!data.text_under_banner" class="row">
          <div class="small-12 columns">
            <blockquote v-if="data.quote" v-text="data.quote"></blockquote>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.text_under_banner" class="row expanded quote-under-banner-image">
      <div class="columns small-12 medium-4 large-3">
        <div class="inner">
          <h6 class="quote-small" v-text="data.quote"></h6>
          <h6 class="credittext-small">
            <span v-if="data.person_credit" v-text="data.person_credit"></span>
            <span v-if="data.person_credit && data.publication">,&nbsp;</span>
            <span v-if="data.publication" v-text="data.publication"></span>
          </h6>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
@import "../../styles/scss/component/image-banner";
</style>

<script>
import BaseBlock from "./Base";

export default {
  extends: BaseBlock,
  data() {
    return {
      defaultColorMode: "dark",
      componentClass: "quotecontainer",
      bannerImageURL: ""
    };
  },
  methods: {
    calculateWindowWidth() {
      var winWidth = window.innerWidth;
      if (winWidth < 350) {
        this.bannerImageURL = this.data.background_image.sizes.medium;
      }
      if (winWidth < 1100) {
        this.bannerImageURL = this.data.background_image.sizes.large;
      }
      if (winWidth > 1100) {
        this.bannerImageURL = this.data.background_image.url;
      }
    }
  },
  created() {},
  mounted() {
    window.addEventListener("resize", this.calculateWindowWidth);
    this.calculateWindowWidth();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateWindowWidth);
  }
};
</script>